import React from 'react';
import { ModalTitle } from '../blocks.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

/* eslint-disable max-lines */
var Title = function Title(_ref) {
  var modalTitle = _ref.modalTitle,
      modalType = _ref.modalType;
  return /*#__PURE__*/React.createElement(ModalTitle, {
    classProps: {
      type: modalType
    }
  }, modalTitle);
};

export default Title;
export { Title };
//# sourceMappingURL=Title.js.map
